import { chatbotHttp as api } from "./chatbotApi";

const base = (botId) => `/bots/${botId}/scheduling`;
const unwrap = (r) => r.data?.data;

export const getSchedulingErrorMessage = (err, fallback = "Something went wrong.") => {
  const body = err?.response?.data;
  if (body?.message && body.message !== "ok") return body.message;
  const detail = body?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        const field = Array.isArray(d?.loc) ? d.loc.filter((p) => p !== "body").join(".") : "";
        const msg = (d?.msg || "Invalid value").replace(/^Value error, /, "");
        return field ? `${field}: ${msg}` : msg;
      })
      .join("; ");
  }
  return err?.message || fallback;
};

// Settings
export const getSchedulingSettings = (botId) => api.get(`${base(botId)}/settings`).then(unwrap);
export const saveSchedulingSettings = (botId, data) => api.put(`${base(botId)}/settings`, data).then(unwrap);
export const sendBookingFlow = (botId, to) =>
  api.post(`${base(botId)}/whatsapp-flow/send`, { to }).then(unwrap);

// Providers
export const listProviders = (botId, params) => api.get(`${base(botId)}/providers`, { params }).then(unwrap);
export const getProvider = (botId, id) => api.get(`${base(botId)}/providers/${id}`).then(unwrap);
export const createProvider = (botId, data) => api.post(`${base(botId)}/providers`, data).then(unwrap);
export const updateProvider = (botId, id, data) => api.patch(`${base(botId)}/providers/${id}`, data).then(unwrap);
export const setProviderServices = (botId, id, serviceIds) =>
  api.put(`${base(botId)}/providers/${id}/services`, { service_ids: serviceIds }).then(unwrap);

// Schedules
export const replaceWeeklyHours = (botId, providerId, hours) =>
  api.put(`${base(botId)}/providers/${providerId}/schedules/weekly`, { hours }).then(unwrap);
export const createSchedule = (botId, providerId, data) =>
  api.post(`${base(botId)}/providers/${providerId}/schedules`, data).then(unwrap);
export const deleteSchedule = (botId, providerId, scheduleId) =>
  api.delete(`${base(botId)}/providers/${providerId}/schedules/${scheduleId}`).then(unwrap);

// Services
export const listServices = (botId, params) => api.get(`${base(botId)}/services`, { params }).then(unwrap);
export const createService = (botId, data) => api.post(`${base(botId)}/services`, data).then(unwrap);
export const updateService = (botId, id, data) => api.patch(`${base(botId)}/services/${id}`, data).then(unwrap);

// Availability
export const getAvailableSlots = (botId, params) =>
  api.get(`${base(botId)}/availability/slots`, { params }).then(unwrap);

// Customers
export const searchCustomers = (botId, params) => api.get(`${base(botId)}/customers`, { params }).then(unwrap);
export const getCustomer = (botId, id) => api.get(`${base(botId)}/customers/${id}`).then(unwrap);
export const createCustomer = (botId, data) => api.post(`${base(botId)}/customers`, data).then(unwrap);
export const updateCustomer = (botId, id, data) => api.patch(`${base(botId)}/customers/${id}`, data).then(unwrap);

// Appointments
export const listAppointments = (botId, params) =>
  api.get(`${base(botId)}/appointments`, { params }).then(unwrap);
export const createAppointment = (botId, data) => api.post(`${base(botId)}/appointments`, data).then(unwrap);
export const updateAppointment = (botId, id, data) =>
  api.patch(`${base(botId)}/appointments/${id}`, data).then(unwrap);
export const cancelAppointment = (botId, id, data) =>
  api.post(`${base(botId)}/appointments/${id}/cancel`, data).then(unwrap);
export const completeAppointment = (botId, id) =>
  api.post(`${base(botId)}/appointments/${id}/complete`, {}).then(unwrap);
export const markNoShow = (botId, id) => api.post(`${base(botId)}/appointments/${id}/no-show`, {}).then(unwrap);

// Public booking page (no login)
const publicBase = (botId) => `/public/bots/${encodeURIComponent(botId)}/booking`;
export const getPublicBooking = (botId) => api.get(publicBase(botId)).then(unwrap);
export const getPublicDates = (botId, params) => api.get(`${publicBase(botId)}/dates`, { params }).then(unwrap);
export const getPublicSlots = (botId, params) => api.get(`${publicBase(botId)}/slots`, { params }).then(unwrap);
export const createPublicBooking = (botId, data) => api.post(publicBase(botId), data).then(unwrap);
